import type { WebhookEventType, WebhookSubscriptionView } from "./api";

/** A firm's subscription: whether it follows the catalogue, and what it
 *  delivers today. */
export function formatWebhookSubscription(
  subscription: WebhookSubscriptionView,
): string {
  const kept =
    subscription.mode === "default" ? "catalogue default" : "fixed list";
  return `${kept}: ${formatWebhookEventTypes(subscription.event_types)}`;
}

/** An event type filter: `null` is no filter (every event). */
export function formatWebhookEventTypes(
  eventTypes: readonly WebhookEventType[] | null | undefined,
): string {
  if (eventTypes == null) {
    return "all events";
  }
  if (eventTypes.length === 0) {
    return "none";
  }
  return eventTypes.join(", ");
}
